export const FORM_ITEM_FLEX_WIDTH_FALLBACK = 6;
